import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { ConfirmHost } from './common/ConfirmDialog';
import Dashboard from './pages/Dashboard/Dashboard';
// V1 customer admin pages retired — CustomerList / ActivateCustomers /
// CreateCustomer / CreateService / CustomerService / ManageService all
// queried dropped endpoints. Replaced by Customerslist.js (canonical).
import './App.css';
import ComingSoon from './pages/ComingSoon';
import Login from './pages/Login/Index';
import RequestStatus from './pages/number_portability/RequestStatus';
import EndPoints from './pages/ip_switches/end_points';
import Invoices from './pages/billing/Invoices';
import AgentSubscriptions from './pages/billing/AgentSubscriptions';
import AgentSubscriptionDetail from './pages/billing/AgentSubscriptionDetail';

import ManageTickets from './pages/supports/tickets/manage_tickets';
import CreateTickets from './pages/supports/tickets/create_tickets';
import ViewTickets from './pages/supports/tickets/view_tickets';

import RepliesList from './pages/supports/predefinedreplies/list';
import AddPreDefReplies from './pages/supports/predefinedreplies/add';

import NoteList from './pages/supports/customernotes/list';
import AddNote from './pages/supports/customernotes/add';

import CategoryList from './pages/supports/categories/list';
import AddCategory from './pages/supports/categories/add';

import UserDepartment from './pages/manage_admin/UserDepartment/UserDepartment';
import ManageUserDepartment from './pages/manage_admin/UserDepartment/ManageUserDepartment';

import UserLogs from './pages/manage_admin/UserLogs/UserLogs';

import UserLevel from './pages/manage_admin/UserLevel/UserLevel';
import ManageUserLevel from './pages/manage_admin/UserLevel/ManageUserLevel';

import UserList from './pages/manage_admin/UserList/UserList';
import ManageUserList from './pages/manage_admin/UserList/ManageUserList';
import ChangePassword from './pages/manage_admin/UserList/ChangePassword';
import ChangeLevel from './pages/manage_admin/UserList/ChangeLevel';


import UserMenu from './pages/manage_admin/UserMenu/UserMenu';

import MenuPermission from './pages/manage_admin/MenuPermission/MenuPermission';


import Revenue from './pages/reports/Revenue';

import UserDoc from './pages/others/user_documents/list';
import ManageList from './pages/others/user_documents/manageList';

import Documents from './pages/others/documents/list';
import MngList from './pages/others/documents/manageList';
import HelpDocList from './pages/supports/helpdocuments/list';
import ManageHelpDoc from './pages/supports/helpdocuments/add';


import PrivateRoutes from './common/PrivateRoutes';
import MenuPermission2 from './pages/manage_admin/MenuPermission/MenuPermission2';
import ProductsList from './pages/settings/products';
import AgentPlansList from './pages/settings/AgentPlans';
import PhoneNumberPricing from './pages/settings/PhoneNumberPricing';
import Branding from './pages/settings/Branding';
import FreeTrials from './pages/settings/FreeTrials';
import TermsAndConditions from './pages/settings/TermsAndConditions';
import HelpVideos from './pages/help_center/HelpVideos';
import HelpCategories from './pages/help_center/HelpCategories';
import PhoneVerifications from './pages/settings/PhoneVerifications';
import PortRequests from './pages/settings/PortRequests';
import PaymentBehavior from './pages/settings/PaymentBehavior';
import Coupons from './pages/settings/Coupons';
// Calling V2 — Calling Agent V2 admin pages.
import CallingV2Templates from './pages/calling_v2/CallingV2Templates';
import CallingV2TemplateEditor from './pages/calling_v2/CallingV2TemplateEditor';
import CallingV2KnowledgeTemplates from './pages/calling_v2/CallingV2KnowledgeTemplates';
import CallingV2IVRTemplates from './pages/calling_v2/CallingV2IVRTemplates';
import CallingV2Tools from './pages/calling_v2/CallingV2Tools';
import CallingV2HoldMusic from './pages/calling_v2/CallingV2HoldMusic';
import CallingV2SummaryConfig from './pages/calling_v2/CallingV2SummaryConfig';
import CustomersListNew from './pages/Customers/Customerslist';
import CustomerDetail from './pages/Customers/CustomerDetail';
import ManageSupportTickets from './pages/supports/manageSupport';
import TicketCategorieList from './pages/supports/TicketCategorie';
import TicketsubCategorieList from './pages/supports/TicketsubCategorie';
import { useEffect } from 'react';
// Phase 5: Buycredit + Creditconfig removed (wallet retired).
import ChatbotEdit from './pages/chatbot/chatbot';
import AIworkflow from './pages/AgentCreation/AIworkflow';
import AIWorkflowEdit from './pages/AgentCreation/AIWorkflowEdit';

import ChatbotsList from './pages/chatbot/chatbotslist';
import ChatbotHolder from './pages/chatbot/chatbotholder';

function App() {

	// useEffect(()=>{
	// 	const fetchMenuListApi = async () => {   
	// 		let role_id = sessionStorage.getItem('user_type')
	// 		try { 
	// 			const response      = await axios.get(`/api/admin/module-mappings/?role_id=${role_id}`); 
	// 			const response_data = response.data   
	// 			if (response.status === 200) { 
	// 				const itemsArray = response_data.results; 
	// 				sessionStorage.setItem('modulepermissions',  JSON.stringify(itemsArray))
	// 			} 

	// 		} catch (error) {  
	// 			// triggerAlert('error', 'Oops...', 'Something went wrong..');
	// 		}
	// 	};
	// 	if(sessionStorage.getItem('user_type')){
	// 		fetchMenuListApi()
	// 	}

	// }, [])

	return (
		<Router>
			<Routes>
				<Route element={<PrivateRoutes />}>
					<Route exact path="/" element={<Dashboard />} />
					<Route exact path="/dashboard" element={<Dashboard />} />

					<Route exact path="/chatbots/:chatbotId" element={<ChatbotHolder />} />
					<Route exact path="customers/customerslist" element={<CustomersListNew />} />
					<Route exact path="customers/customerslist/:orgId" element={<CustomerDetail />} />
					{/* Legacy V1 customer URLs redirect to the canonical list. */}
					<Route exact path="customers/customer_list" element={<Navigate to="/customers/customerslist" replace />} />
					<Route exact path="/customers/active_customers" element={<Navigate to="/customers/customerslist" replace />} />
					<Route exact path="/customers/customer_service" element={<Navigate to="/customers/customerslist" replace />} />
					<Route exact path="/customers/manage_service" element={<Navigate to="/customers/customerslist" replace />} />

					<Route exact path="/billing/invoice" element={<Invoices />} />
					<Route exact path="/billing/subscriptions" element={<AgentSubscriptions />} />
					<Route exact path="/billing/subscriptions/:subId" element={<AgentSubscriptionDetail />} />

					<Route exact path="/number_portability/request_status" element={<RequestStatus />} />
					<Route exact path="/endpoints/endpoints" element={<EndPoints />} />

					<Route exact path="/support/manage_tickets" element={<ManageTickets />} />
					<Route exact path="/support/managetickets" element={<ManageSupportTickets />} />
					<Route exact path="/support/create_tickets" element={<CreateTickets />} />
					<Route exact path="/support/manage_tickets/view_tickets" element={<ViewTickets />} />


					<Route exact path="/support/predefined_replies" element={<RepliesList />} />
					<Route exact path="/support/predefined_replies/create_predefined_replies" element={<AddPreDefReplies />} />

					<Route exact path="/support/customer_notes" element={<NoteList />} />
					<Route exact path="/support/customer_notes/create_customer_notes" element={<AddNote />} />
					<Route exact path="/support/help_documents" element={<HelpDocList />} />
					<Route exact path="/support/manage_help_documents" element={<ManageHelpDoc />} />

					<Route exact path="/support/categories" element={<CategoryList />} />
					<Route exact path="/support/categorieslist" element={<TicketCategorieList />} />
					<Route exact path="/support/subcategorieslist" element={<TicketsubCategorieList />} />
					<Route exact path="/support/categories" element={<CategoryList />} />
					<Route exact path="/support/create_categories" element={<AddCategory />} />

					<Route exact path="/coming_soon" element={<ComingSoon />} />

					<Route exact path="/manage_admin/user_department" element={<UserDepartment />} />
					<Route exact path="/manage_admin/user_department/manage_user_department" element={<ManageUserDepartment />} />



					<Route exact path="/manage_admin/user_level" element={<UserLevel />} />
					<Route exact path="/manage_user/user_roles" element={<UserLevel />} />
					<Route exact path="/manage_admin/user_level/manage_user_level" element={<ManageUserLevel />} />

					<Route exact path="/manage_admin/user_list" element={<UserList />} />
					<Route exact path="/manage_user/user_list" element={<UserList />} />
					<Route exact path="/settings/products" element={<ProductsList />} />
					{/* Old subscription-plan page retired — superseded by Agent Plans
					    (the new billing.AgentPlan catalog). Redirect old links. */}
					<Route exact path="/settings/plans" element={<Navigate to="/settings/agent-plans" replace />} />
					<Route exact path="/settings/agent-plans" element={<AgentPlansList />} />
					<Route exact path="/settings/phone-number-pricing" element={<PhoneNumberPricing />} />
					<Route exact path="/settings/branding" element={<Branding />} />
					<Route exact path="/settings/free-trials" element={<FreeTrials />} />
					<Route exact path="/settings/terms-and-conditions" element={<TermsAndConditions />} />
					<Route exact path="/settings/phone-verifications" element={<PhoneVerifications />} />
					<Route exact path="/settings/port-requests" element={<PortRequests />} />
					<Route exact path="/settings/payment-behavior" element={<PaymentBehavior />} />
					<Route exact path="/settings/coupons" element={<Coupons />} />
					{/* Help Center — video library the customer portal searches. */}
					<Route exact path="/settings/help-center-videos" element={<HelpVideos />} />
					<Route exact path="/settings/help-center-categories" element={<HelpCategories />} />
					{/* Calling V2 */}
					<Route exact path="/v2/templates" element={<CallingV2Templates />} />
					<Route exact path="/v2/templates/new" element={<CallingV2TemplateEditor />} />
					<Route exact path="/v2/templates/:id" element={<CallingV2TemplateEditor />} />
					<Route exact path="/v2/knowledge-templates" element={<CallingV2KnowledgeTemplates />} />
					<Route exact path="/v2/ivr-templates" element={<CallingV2IVRTemplates />} />
					<Route exact path="/v2/tools" element={<CallingV2Tools />} />
					<Route exact path="/v2/hold-music" element={<CallingV2HoldMusic />} />
					<Route exact path="/v2/summary-config" element={<CallingV2SummaryConfig />} />
					<Route exact path="/manage_admin/user_list/manage_user_list" element={<ManageUserList />} />
					<Route exact path="/manage_user/user_list/manage_user_list" element={<ManageUserList />} />
					<Route exact path="/manage_admin/user_list/change_level" element={<ChangeLevel />} />
					<Route exact path="/manage_admin/user_list/change_password" element={<ChangePassword />} />

					<Route exact path="/manage_admin/user_menu" element={<UserMenu />} />

					<Route exact path="/manage_admin/menu_permission" element={<MenuPermission />} />
					<Route exact path="/manage_user/access_privileges" element={<MenuPermission2 />} />


					<Route exact path="/reports/revenue" element={<Revenue />} />
					<Route exact path="/reports/user_logs_list" element={<UserLogs />} />

					<Route exact path="/others/user_documents" element={<UserDoc />} />
					<Route exact path="/others/manage_user_documents" element={<ManageList />} />


					<Route exact path="/others/documents" element={<Documents />} />
					<Route exact path="/others/manage_documents" element={<MngList />} />
					{/* Settings → Promo Code route removed; broken legacy UI deleted, rebuild pending */}
					<Route exact path="/configurations/chatbotconfigurations" element={<ChatbotsList />} />
					<Route exact path="/configurations/aiworkflows" element={<AIworkflow />} />
					<Route exact path="/configurations/aiworkflowedit" element={<AIWorkflowEdit />} />
				</Route>

				<Route exact path="/login" element={<Login />} />
			</Routes >

			<ConfirmHost />
		</Router>
	);
}

export default App;
